import {ReactNode, Component} from 'react';

import {ActionStyle, ActionType, ButtonStyle, ButtonWidth} from 'components/design-guide';
import Action from 'components/design-guide/Action';
import {StaticConfig} from 'config/staticConfig';
import MessageBanner from 'shared/components/MessageBanner';
import {ensighten} from 'shared/Ensighten/components';
import {reportError} from 'shared/Errors/utils';
import FormattedMessage from 'shared/IntlFormatMessage/components/FormattedMessage';
import {GLOBAL_ERRORS, GLOBAL_TRANSLATIONS} from 'shared/IntlFormatMessage/translations/globalTranslations';
import {formatHTML} from 'shared/IntlFormatMessage/utils/intl';

interface Props {
  children: ReactNode;
  contextual?: boolean;
}

export class ErrorBoundary extends Component<Props> {
  state = {hasError: false, isJSChunkError: false};

  componentDidCatch(error: Error) {
    this.setState({hasError: true});
    reportError(error);
    if (error.name.includes('ChunkLoadError')) {
      ensighten.ensightenLogger({logInfo: 'Chunk failed to load'});
      this.setState({isJSChunkError: true});
    }
  }

  render() {
    const {children, contextual} = this.props;
    const isJSChunkError = this.state.isJSChunkError && !StaticConfig.mobileApplicationMode;

    const actionButton = isJSChunkError ? (
      <Action
        name="refresh"
        actionStyle={ActionStyle.BUTTON}
        styleProps={{buttonStyle: ButtonStyle.DESTRUCTIVE, width: ButtonWidth.FULL_AT_MOBILE}}
        actionType={ActionType.ONCLICK}
        typeProps={{type: 'button', onClick: () => window.location.reload()}}>
        <FormattedMessage message={GLOBAL_TRANSLATIONS.REFRESH} />
      </Action>
    ) : undefined;

    return this.state.hasError ? (
      <MessageBanner
        type="error"
        subtext={
          <FormattedMessage
            message={GLOBAL_ERRORS.PAGE_ERROR_DEFAULT}
            values={{includeRefresh: isJSChunkError, ...formatHTML}}
          />
        }
        {...{contextual, actionButton}}
      />
    ) : (
      children
    );
  }
}

export default ErrorBoundary;
